import React from "react";
import {
  EuiBadge,
  EuiBasicTable,
  EuiSpacer,
  EuiProvider,
  EuiForm,
  EuiFormRow,
  EuiSelect,
} from "@elastic/eui";

import "@elastic/eui/dist/eui_theme_light.css";

let columns = [
  {
    field: "ticker",
    name: "Ticker",
    sortable: true,
  },
  {
    field: "currentPrice",
    name: "Current Price",
    sortable: true,
  },
  {
    field: "highPrice",
    name: "High Price",
    sortable: true,
  },
  {
    field: "buyRecommendation",
    name: "Should I Buy",
    sortable: true,
    render: (buy) => {
      const color = buy ? "success" : "danger";
      const label = buy ? "Buy" : "Don't Buy";
      return <EuiBadge color={color}>{label}</EuiBadge>;
    },
  },
];

const groupOptions = [
  { value: "--Pick an industry--", text: "--Pick an industry--" },
  { value: "Tech", text: "Tech" },
  { value: "Airlines", text: "Airlines" },
  { value: "Social Media", text: "Social Media" },
];

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stockData: [],
      selectedStocks: [],
    };
    this.fetchStocks = this.fetchStocks.bind(this);
  }

  componentDidMount() {
    this.fetchStocks(this.state.selectedStocks);
  }

  setTickers = (e) => {
    let tickers = [];
    if (e.target.value === "Tech") {
      tickers = ["AAPL", "AMZN", "FB"];
    } else if (e.target.value === "Airlines") {
      tickers = ["JETS", "AAL", "DAL"];
    } else if (e.target.value === "Social Media") {
      tickers = ["HERO", "FB", "TW  "];
    }
    this.setState({ selectedStocks: tickers });
    this.fetchStocks(tickers);
    return tickers;
  };

  fetchStocks = (stockArray) => {
    let stockData = [];

    stockArray.forEach((stock) => {
      let StockSymbol = stock;
      let finnAPI = `https://finnhub.io/api/v1/quote?symbol=${StockSymbol}&token=bspk5a7rh5rehfh23jbg`;
      fetch(finnAPI)
        .then((response) => response.json())
        .then((data) => {
          stockData.push({
            ticker: StockSymbol,
            currentPrice: data.c,
            highPrice: data.h,
            buyRecommendation: data.c < data.h * 0.95 ? true : false,
          });
          console.log("first then, array", stockData); // this is doing what i want
          this.setState({ stockData: stockData });
        });
    });

    return stockData;
  };

  renderTable() {
    return <EuiBasicTable items={this.state.stockData} columns={columns} />;
  }

  renderForm() {
    return (
      <>
        <EuiForm>
          <EuiFormRow label="Ticker">
            <EuiSelect
              options={groupOptions}
              onChange={(e) => this.setTickers(e)}
            />
          </EuiFormRow>
        </EuiForm>
      </>
    );
  }

  render() {
    return (
      <div>
        <EuiProvider>
          <EuiSpacer size="l" />
          {this.renderForm()}
          <EuiSpacer size="l" />
          {this.renderTable()}
        </EuiProvider>
      </div>
    );
  }
}

export default App;
